import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, ViewEncapsulation, ElementRef, Inject, AfterContentInit, ViewChild } from '@angular/core';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { DatePipe } from '@angular/common';

@Component({
  templateUrl: './investment-resume.component.html',
  styleUrls: [ './investment-resume.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class InvestmentResumeComponent extends DialogPanelComponentContent{

    public investmentValue: number;
    public isDayTrade: boolean;
    public usingWarranty: boolean;
    public warrantyValue: number;
    public planned: boolean;
    public incompatibleProfile: boolean;
    public purchase: boolean;
    public unlocked: boolean;
    public isFuture: boolean;
    public brokerage: number;
    public brokerageFactor: number;
    public disposableSubscriptions: Subscription[] = [];
    public loading: boolean = false;
    public suitability: string;
    public hasAgreedToSuitabilityRisk: boolean = false;
    public hasUserCheckedSuitabilityRisk: boolean = false;
    public hasBypassedSuitabilityForCurrentInvestment = false;
    public DEFAULT_TIME_F_IBOVESPA = '16:30';
    public DEFAULT_TIME_F_BMF = '17:30';

    @ViewChild('confirmButton', {static: true}) public confirmButton: ElementRef;

    public sendInvestmentSubject: Subject<boolean> = new Subject<boolean>();

    public tooltipTax: string = `<div>         
            <div class='pop-title'>Só ganhamos se você ganhar.</div>
            <div class='pop-content'>Quando segue as nossas recomendações na Bolsa de Valores, 
            nós só cobramos taxa de corretagem se você tiver lucro. Se perder a gente não cobra nada.</div>
        </div>`;

    public get tooltipTriggerTrade(): string {
        return `<div>         
            <div class='pop-title'>Encerramento automático</div>
            <div class='pop-content'>O investimento vai encerrar hoje, após ${ this.timeLimitToDaytrade }, 
            se não atingir o valor do lucro ou prejuízo.</div>
        </div>`;
    }

    public get timeLimitToDaytrade(): string {
        return this.isFuture ? this.DEFAULT_TIME_F_BMF : this.DEFAULT_TIME_F_IBOVESPA;
    }

    public get showSuitabilityDisclaimer(): boolean {
        return this.suitability !== 'Arrojado'
            && this.suitability !== 'Sem Perfil'
            && !this.hasBypassedSuitabilityForCurrentInvestment;
    }

    public get isConfirmDisabled(): boolean {
        return this.showSuitabilityDisclaimer
            && (!this.hasUserCheckedSuitabilityRisk || !this.hasAgreedToSuitabilityRisk);
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) private data,
        public elementRef: ElementRef,
        public store: Store<AppState>,
        private dialogReference: MatDialogRef<InvestmentResumeComponent>,
        private datePipe: DatePipe,
    ) {

        super(elementRef, true);
        this.purchase = data.purchase;
        this.investmentValue = data.investmentValue;
        this.isDayTrade = data.isDayTrade;
        this.usingWarranty = data.usingWarranty;
        this.warrantyValue = data.warrantyValue;
        this.planned = data.planned;
        this.incompatibleProfile = data.incompatibleProfile;
        this.unlocked = data.unlocked;
        this.isFuture =  data.isFuture;
        this.brokerage = data.brokerage;
        this.brokerageFactor = data.brokerageFactor;
        this.suitability = data.suitability;
        this.hasAgreedToSuitabilityRisk = this.hasBypassedSuitabilityForCurrentInvestment = this.suitability === 'Arrojado';

        this.disposableSubscriptions.push(
            this.store.select((state) => state.exchange.tradingTime)
            .filter((tradingTime) => !!(tradingTime))
            .subscribe((tradingTime) => {
                const limitDayTradeStock = this.normalizeDate((tradingTime.limitDayTradeStock as string));
                const limitDayTradeFuture = this.normalizeDate((tradingTime.limitDayTradeFuture as string));

                this.DEFAULT_TIME_F_IBOVESPA = this.datePipe.transform(limitDayTradeStock, 'HH:mm');
                this.DEFAULT_TIME_F_BMF = this.datePipe.transform(limitDayTradeFuture, 'HH:mm');
            }),

            this.store.select(state => state['suitabilityBypassAgreement'])
                .filter(data => !!data)
                .subscribe(data => {
                    if (this.suitability !== 'Arrojado') {
                        this.hasBypassedSuitabilityForCurrentInvestment = this.hasAgreedToSuitabilityRisk = this.isFuture 
                            ? data.suitabilityBypassAgreement.bmfAccepted 
                            : data.suitabilityBypassAgreement.bovespaAccepted
                    }
                })
        );
    }

    /** 
     * Envia o investimento 
     */
    public sendInvestment() {
        this.loading = true;
        this.sendInvestmentSubject.next(true);
    }

    public onSuitabilityRiskChanged(accepted: boolean) {
        this.hasAgreedToSuitabilityRisk = accepted;
        this.hasUserCheckedSuitabilityRisk = true;
    }

    /**
     * Fecha o modal
     * @param confirm 
     */
    public closeDialog(confirm: boolean) {
        super.close(this.dialogReference, confirm);
    }

    /**
     * Método para ajustar a string do tradingHour que está vindo da webapi
     * GAMBIARRA!! REMOVER QUANDO ARRUMAREM NA API.
     */
    public normalizeDate(date: string) {
        const today = new Date();
        const todayIso = today.toISOString().split("T");
        const dateISO = date.split("T");
        return `${todayIso[0]}T${dateISO[1]}`;
    }

    /**
     * Se houve sucesso ou não no envio
     * @param confirm 
     */
    public haveSuccess(confirm: boolean) {
        if(confirm) {
            this.closeDialog(confirm);
        }
        else {
            this.loading = false;
        }
    }
}